/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { interviewFiltersSchema } from './interview-filters';

/** ReadUsersOpportunitiesInterviewsRequest — dark-roast DTO: UserOpportunityInterviewsSearchRequestDto */
export const readUsersOpportunitiesInterviewsRequestSchema = z.object({ "filters": z.lazy(() => interviewFiltersSchema), "order": z.enum(["asc", "desc"]), "page": z.number(), "pageSize": z.number(), "search": z.string().nullish(), "sort": z.string(), "timezone": z.string() });
export type ReadUsersOpportunitiesInterviewsRequest = z.infer<typeof readUsersOpportunitiesInterviewsRequestSchema>;
